<template>
    <el-dialog class="editor-dialog" :title="'HTC'+ String(model.seq).padStart(5, '0')+'合同详情'" append-to-body :visible.sync="visible" :show-close="false" width="40%" top="3vh">
      <el-descriptions title="垂直带边框列表" direction="vertical" :column="1" border>     
        <el-descriptions-item label="合同描述">{{model.description}}</el-descriptions-item>
        <el-descriptions-item label="合同金额数量"><el-tag size="small">{{model.currency=='CNY'?model.contractAmount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' }):model.contractAmount.toLocaleString('en-US', { style: 'currency', currency:'USD' })}}</el-tag></el-descriptions-item>
        <el-descriptions-item label="合同货期(天)">
          <el-tag size="small" v-if="model.deliveryTime">{{model.deliveryTime}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="销售方">
          <el-tag size="small">{{calcSupplier(model.party)}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="签署日期">
          <el-tag size="small">{{calcDate(model.signedDate)}}</el-tag>        
        </el-descriptions-item>
        <el-descriptions-item label="附件">
          <div style="display:flex;flex-flow:row wrap;justify-content:start;">
            <div v-for="(file,index) in model.attachments" :key="index" style="position: relative;margin:0 3px">
              <el-tooltip class="item" effect="dark" :content="file.filename" placement="top">
                <el-image class="image" v-if="['.pdf','.PDF'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pdf.png')" fit="cover" @click="previewPDF(file.path,file.filename)"></el-image>
                <el-image class="image" v-if="['.xls','.xlsx','.XLS','.XLSX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/xlsx.png')" fit="cover" @click="previewExcel(file.path,file.filename)"></el-image>
                <el-image class="image" v-if="['.doc','.docx','.DOC','.DOCX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/docx.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                <el-image class="image" v-if="['.ppt','.pptx','.PPT','.PPTX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pptx.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                <el-image class="image" v-if="['.avi','.mpg','.mpeg','.wmv','.mpeg-4','.rmvb','.mkv','.flv','.mov','.mp4','.3gp'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/video.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
                <el-image class="image" v-if="['.jpg','.jpeg','.png','.bmp','.gif','.tiff','.JPG','.JPEG','.PNG','.BMP','.GIF'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/jpeg.png')" fit="cover" @click="previewImage(file.path)"></el-image>
                <el-image class="image" v-else :src="require('@/assets/images/format/other.png')" fit="cover" @click="previewAttachment(file.path)"></el-image>
              </el-tooltip>
            </div>
          </div>    
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </template>
  <script>
  import http from '@/http'
  import dateformat from 'dateformat'
  export default {
  data() {
    return {
      visible: false,
      supplierList:[],
      model:{contractAmount:0},
      contractId:'',
    };
  },
  methods:{
    async previewAttachment(file){
      const res= await http.get('/oss/signatureUrl',{params:{url:file}})  
      window.open(res.data)
    },
    async previewPDF(file,filename){
      const res= await http.get('/oss/signatureUrl',{params:{url:file}})  
      this.pdfViewer(res.data,filename,()=>{})  
    },
    async previewExcel(file,filename){
      const res= await http.get('/oss/signatureUrl',{params:{url:file}})  
      this.excelViewer(res.data,filename,()=>{})  
    },
    async previewImage(file){
      const res= await http.get('/oss/signatureUrl',{params:{url:file}})  
      this.$hevueImgPreview({url:res.data})
    },
    calcDate(date){
      return dateformat(date, 'yyyy-mm-dd')
    },
    calcSupplier(supplier){
      const s=this.supplierList.find(item=>item._id==supplier)
      if(s){
        return s.name        
      }
    }, 
    async fetchSupplier(){
      const res=await http.get('/purchase/supplier');
      this.supplierList=res.data
    },
    async fetchContract() {
      const res = await http.get(`contract/id/${this.contractId}`);
      this.model = res.data
    }
  },
  created(){
    this.fetchContract()
    this.fetchSupplier()
  }
  };
  </script>
  <style scoped>
  .editor-dialog>>>.el-dialog__header {
    text-align: center !important;
    padding:15px 5px 5px 5px;
  }
  .editor-dialog>>>.el-dialog__body {
    padding:20px 10px;
  }
  .editor-dialog>>>.el-dialog__title {
    font-weight: 700 !important;
  }
  .editor-dialog>>>.el-textarea__inner{
    font-family: Arial, Helvetica, sans-serif;
  }
  .editor-dialog>>>.el-descriptions__header{
    display: none;
  }
  .image{
    height: 40px;
    width: 40px;
    margin: auto;
    cursor: pointer;
  }
  </style>
  